import React, { useState, useEffect } from 'react';
import { VOTER_ORANGE, voterIcons } from '../../component/voterCardIcons';
import '../../style/speakSearch.css';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppId } from '../../context/AppIdContext';
import Header from '../../component/header';
import WhatsappSlipButton from '../../component/WhatsappSlipButton';
import PracharButton from '../../component/PracharButton';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const BoothWiseVoter = () => {
    const [voters, setVoters] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [filterStatus, setFilterStatus] = useState('all'); // 'all', 'available', 'not_available', 'pending'
    const [isFilterDropdownOpen, setIsFilterDropdownOpen] = useState(false);
    const itemsPerPage = 50;

    const { appId, language, userId } = useAppId();
    const location = useLocation();
    const navigate = useNavigate();

    // Safely get booth_no from the previous page's route state
    const boothNo = location.state?.selectedBoothNo || location.state?.booth_no || "";
    const lang = language || 'en';

    // Helper function to convert Status 'D', 'C', 'P', 'N' to Full Form
    const getStatusFullForm = (statusCode) => {
        switch (statusCode?.toUpperCase()) {
            case 'D': return 'Doubtful';
            case 'C': return "Can't Say";
            case 'P': return 'Positive';
            case 'N': return 'Negative';
            default: return statusCode || 'Voted';
        }
    };

    // Get filter button text
    const getFilterButtonText = () => {
        switch (filterStatus) {
            case 'available': return "Survey Available";
            case 'not_available': return "Survey Not Available";
            case 'pending': return "Survey Pending";
            default: return "All";
        }
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isFilterDropdownOpen && !event.target.closest('.filter-dropdown-container')) {
                setIsFilterDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isFilterDropdownOpen]);

    // Translation dictionary - enhanced to match SpeakAndSearch
    const t = {
        en: {
            title: `Booth ${boothNo} - Voters`,
            loadingData: "Loading Voters...",
            searchPlaceholder: "Search by Name, Epic No, or Mobile...",
            noResults: "No voters found matching",
            noData: "No voters available in this booth.",
            fs: "F/S :",
            address: "Address :",
            srNo: "Sr No. :",
            mobile: "Mobile :",
            idCardNo: "ID Card No :",
            boothNoLabel: "Booth No :",
            houseNo: "House No :",
            votingLoc: "Voting Loc :",
            call: "Call",
            text: "Text",
            slip: "Slip",
            prachar: "Prachar",
            print: "Print",
            family: "Family",
            addToGroup: "Add to Group",
            addSurvey: "Add Survey",
            all: "All",
            surveyAvailable: "Survey Available",
            surveyNotAvailable: "Survey Not Available",
            surveyPending: "Survey Pending",
            editMobileTitle: "Update Mobile Number",
            mobilePlaceholder: "Enter 10-digit mobile number",
            mobileErrorLength: "Mobile number must be 10 digits",
            mobileErrorStart: "Number must start with 6, 7, 8, or 9",
            cancel: "Cancel",
            save: "Save",
            saving: "Saving...",
            mobileUpdateSuccess: "Mobile number updated successfully!",
            mobileUpdateFailed: "Failed to update mobile number.",
            mobileUpdateError: "An error occurred while updating the mobile number.",
            mobileNotAvailable: "Mobile number is not available for this voter.",
            addressNotAvailable: "Address not available!"

        },
        hi: {
            title: `बूथ ${boothNo} - मतदाता`,
            loadingData: "मतदाता लोड हो रहे हैं...",
            searchPlaceholder: "नाम, एपिक नंबर या मोबाइल द्वारा खोजें...",
            noResults: "इससे मेल खाने वाला कोई मतदाता नहीं मिला",
            noData: "इस बूथ में कोई मतदाता उपलब्ध नहीं है।",
            fs: "पिता/पति :",
            address: "पता :",
            srNo: "क्र. सं. :",
            mobile: "मोबाइल :",
            idCardNo: "पहचान पत्र नं :",
            boothNoLabel: "बूथ नं :",
            houseNo: "मकान नं :",
            votingLoc: "मतदान स्थान :",
            call: "कॉल",
            text: "संदेश",
            slip: "पर्ची",
            prachar: "प्रचार",
            print: "प्रिंट",
            family: "परिवार",
            addToGroup: "समूह में जोड़ें",
            addSurvey: "सर्वेक्षण जोड़ें",
            all: "सभी",
            surveyAvailable: "सर्वेक्षण उपलब्ध",
            surveyNotAvailable: "सर्वेक्षण अनुपलब्ध",
            surveyPending: "सर्वेक्षण लंबित",
            editMobileTitle: "मोबाइल नंबर अपडेट करें",
            mobilePlaceholder: "10 अंकों का मोबाइल नंबर दर्ज करें",
            mobileErrorLength: "मोबाइल नंबर 10 अंकों का होना चाहिए",
            mobileErrorStart: "नंबर 6, 7, 8, या 9 से शुरू होना चाहिए",
            cancel: "रद्द करें",
            save: "सेव करें",
            saving: "सेव हो रहा है...",
            mobileUpdateSuccess: "मोबाइल नंबर सफलतापूर्वक अपडेट हो गया!",
            mobileUpdateFailed: "मोबाइल नंबर अपडेट करने में विफल।",
            mobileUpdateError: "मोबाइल नंबर अपडेट करते समय एक त्रुटि हुई।",
            mobileNotAvailable: "इस मतदाता के लिए मोबाइल नंबर उपलब्ध नहीं है।",
            addressNotAvailable: "पता उपलब्ध नहीं है!"

        },
        gu: {
            title: `બૂથ ${boothNo} - મતદારો`,
            loadingData: "મતદારો લોડ થઈ રહ્યા છે...",
            searchPlaceholder: "નામ, એપિક નંબર અથવા મોબાઇલ દ્વારા શોધો...",
            noResults: "કોઈ મતદાર મળ્યો નથી",
            noData: "આ બૂથમાં કોઈ મતદારો ઉપલબ્ધ નથી.",
            fs: "પિતા/પતિ :",
            address: "સરનામું :",
            srNo: "ક્રમ નં. :",
            mobile: "મોબાઇલ :",
            idCardNo: "ઓળખપત્ર નં :",
            boothNoLabel: "બૂથ નં :",
            houseNo: "મકાન નં :",
            votingLoc: "મતદાન સ્થળ :",
            call: "કૉલ",
            text: "ટેક્સ્ટ",
            slip: "સ્લિપ",
            prachar: "પ્રચાર",
            print: "પ્રિન્ટ",
            family: "પરિવાર",
            addToGroup: "જૂથમાં ઉમેરો",
            addSurvey: "સર્વે ઉમેરો",
            all: "બધા",
            surveyAvailable: "સર્વે ઉપલબ્ધ",
            surveyNotAvailable: "સર્વે અનુપલબ્ધ",
            surveyPending: "સર્વે બાકી",
            editMobileTitle: "મોબાઇલ નંબર અપડેટ કરો",
            mobilePlaceholder: "10 અંકોનો મોબાઇલ નંબર દાખલ કરો",
            mobileErrorLength: "મોબાઇલ નંબર 10 અંકોનો હોવો જોઈએ",
            mobileErrorStart: "નંબર 6, 7, 8, અથવા 9 થી શરૂ થવો જોઈએ",
            cancel: "રદ કરો",
            save: "સેવ કરો",
            saving: "સેવ થઈ રહ્યું છે...",
            mobileUpdateSuccess: "મોબાઇલ નંબર સફળતાપૂર્વક અપડેટ થયો!",
            mobileUpdateFailed: "મોબાઇલ નંબર અપડેટ કરવામાં નિષ્ફળ.",
            mobileUpdateError: "મોબાઇલ નંબર અપડેટ કરતી વખતે એક ભૂલ આવી.",
            mobileNotAvailable: "આ મતદાર માટે મોબાઇલ નંબર ઉપલબ્ધ નથી.",
            addressNotAvailable: "સરનામું ઉપલબ્ધ નથી!"

        }
    };

    const txt = t[lang] || t.en;
    // --- Edit Mobile State ---
    const [isEditMobileOpen, setIsEditMobileOpen] = useState(false);
    const [editingVoter, setEditingVoter] = useState(null);
    const [newMobile, setNewMobile] = useState('');
    const [isSavingMobile, setIsSavingMobile] = useState(false);



    // --- Edit Mobile API Call ---
    const handleUpdateMobile = async () => {
        if (!newMobile || newMobile.length !== 10) {
            alert(txt.mobileErrorLength);
            return;
        }

        setIsSavingMobile(true);
        try {
            const payload = {
                app_id: appId?.toString(),
                voter_id: editingVoter.idcard_no,
                mobile_no: newMobile,
                modify_by: userId?.toString() || "1"
            };

            const response = await axios.post(`${BASE_URL}/api/upd_voter_mobile`, payload);

            if (response.data.success || response.data.Success === "1") {
                alert(txt.mobileUpdateSuccess);
                setVoters(prev => prev.map(v =>
                    v.id === editingVoter.id ? { ...v, contact_no: newMobile } : v
                ));
                setIsEditMobileOpen(false);
            } else {
                alert(txt.mobileUpdateFailed);
            }
        } catch (error) {
            console.error("Error updating mobile:", error);
            alert(txt.mobileUpdateError);
        } finally {
            setIsSavingMobile(false);
        }
    };



    useEffect(() => {
        if (!appId || !boothNo) {
            navigate(-1);
            return;
        }
        fetchVoters();
    }, [appId, boothNo, navigate]);

    // --- Add to Group API Call (same as SpeakAndSearch) ---
    const handleAddToGroup = async (voter) => {
        try {
            const payload = {
                app_id: appId?.toString(),
                user_id: appId?.toString(),
                idcard: voter.idcard_no
            };

            const response = await axios.post(`${BASE_URL}/api/ins_my_group`, payload);

            if (response.data.success) {
                alert("Added to group successfully!");
            } else {
                alert("Failed to add to group.");
            }
        } catch (error) {
            console.error("Error adding to group:", error);
            alert("An error occurred while adding to the group.");
        }
    };

    // --- WhatsApp Message Generation Logic ---
    const handleWhatsAppShare = async (voter) => {
        if (!voter.contact_no) {
            alert("Mobile number not available for this voter.");
            return;
        }

        try {
            const response = await axios.post(`${BASE_URL}/api/get_receipt_in_all_family_for_wtsp`, {
                app_id: appId,
                voter_id: voter.id,
                user_id: userId
            });

            if (response.data.success && response.data.data && response.data.data.result) {
                const familyMembers = response.data.data.result;
                let message = "";

                familyMembers.forEach((member, index) => {
                    message += `${member.first_detail.replace(/\s+/g, ' ')}\n`;
                    message += `${member.full_name}\n`;
                    message += `${member.middle_name}\n`;
                    message += `${member.sex_age.replace('स्री', 'स्त्री')}\n`;
                    message += `${member.idcard_no}\n`;
                    message += `મતદાન સ્થળ : ${member.eng_polling_location}\n`;
                    message += `મતદાન તા. : ૨૬-૦૪-૨૦૨૬, રવિવાર \n સમય : સવારે ૭.૦૦ થી સાંજે ૬.૦૦ સુધી\n\n`;

                    if (index < familyMembers.length - 1) {
                        message += `----------------------------------------\n\n`;
                    }
                });

                const encodedMessage = encodeURIComponent(message);
                let mobile = voter.contact_no.replace(/\D/g, '');
                if (mobile.length === 10) mobile = '91' + mobile;

                window.open(`https://wa.me/${mobile}?text=${encodedMessage}`, '_blank');

            } else {
                alert("Could not fetch family details.");
            }
        } catch (error) {
            console.error("Error generating WhatsApp slip:", error);
            alert("Error generating message.");
        }
    };

    // --- SMS Message Generation Logic ---
    const handleSmsShare = async (voter) => {
        if (!voter.contact_no) {
            alert("Mobile number not available for this voter.");
            return;
        }

        try {
            const response = await axios.post(`${BASE_URL}/api/get_receipt_in_all_family_for_sms`, {
                app_id: appId,
                voter_id: voter.id,
                user_id: userId
            });

            if (response.data.success && response.data.data && response.data.data.result) {
                const familyMembers = response.data.data.result;
                let message = "";

                familyMembers.forEach((member, index) => {
                    message += `${member.first_detail.replace(/\s+/g, ' ')}\n`;
                    message += `${member.full_name}\n`;
                    message += `${member.middle_name}\n`;
                    message += `${member.sex_age.replace('स्री', 'स्त्री')}\n`;
                    message += `${member.idcard_no}\n`;
                    message += `મતદાન સ્થળ : ${member.eng_polling_location}\n`;
                    message += `મતદાન તા. : ૨૬-૦૪-૨૦૨૬, રવિવાર \n સમય : સવારે ૭.૦૦ થી સાંજે ૬.૦૦ સુધી\n\n`;

                    if (index < familyMembers.length - 1) {
                        message += `----------------------------------------\n\n`;
                    }
                });

                const encodedMessage = encodeURIComponent(message);
                let mobile = voter.contact_no.replace(/\D/g, '');

                // Open native SMS app with pre-filled body
                window.location.href = `sms:${mobile}?body=${encodedMessage}`;

            } else {
                alert("Could not fetch family details for SMS.");
            }
        } catch (error) {
            console.error("Error generating SMS slip:", error);
            alert("Error generating SMS message.");
        }
    };

    const fetchVoters = async () => {
        setLoading(true);
        setCurrentPage(1);
        try {
            const payload = {
                app_id: String(appId),
                booth_no: String(boothNo)
            };

            const response = await axios.post(`${BASE_URL}/api/dis_booth_wise_search`, payload);

            if (response.data.success && response.data.data && response.data.data.result) {
                setVoters(response.data.data.result);
            } else {
                setVoters([]);
            }
        } catch (err) {
            console.error("API Error:", err);
            setVoters([]);
        } finally {
            setLoading(false);
        }
    };

    const filteredVoters = voters.filter(voter => {
        // Apply search filter
        let matchesSearch = true;
        if (searchTerm) {
            const searchLower = searchTerm.toLowerCase();
            matchesSearch = (
                (voter.eng_f_name && voter.eng_f_name.toLowerCase().includes(searchLower)) ||
                (voter.f_eng_surname && voter.f_eng_surname.toLowerCase().includes(searchLower)) ||
                (voter.idcard_no && voter.idcard_no.toLowerCase().includes(searchLower)) ||
                (voter.contact_no && voter.contact_no !== "-" && voter.contact_no.includes(searchLower))
            );
        }

        // Apply status filter
        let matchesStatus = true;
        if (filterStatus === 'available') {
            matchesStatus = voter.voter_available === true;
        } else if (filterStatus === 'not_available') {
            matchesStatus = voter.voter_available === false;
        } else if (filterStatus === 'pending') {
            matchesStatus = voter.voter_available === null;
        }

        return matchesSearch && matchesStatus;
    });

    // --- Pagination Logic (same as SpeakAndSearch) ---
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentVoters = filteredVoters.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredVoters.length / itemsPerPage);

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const getPageNumbers = () => {
        const pageNumbers = [];
        const maxVisibleButtons = 5;
        if (totalPages <= maxVisibleButtons) {
            for (let i = 1; i <= totalPages; i++) pageNumbers.push(i);
        } else {
            pageNumbers.push(1);
            let startPage = Math.max(2, currentPage - 1);
            let endPage = Math.min(totalPages - 1, currentPage + 1);
            if (currentPage <= 3) endPage = 4;
            if (currentPage >= totalPages - 2) startPage = totalPages - 3;
            if (startPage > 2) pageNumbers.push('...');
            for (let i = startPage; i <= endPage; i++) pageNumbers.push(i);
            if (endPage < totalPages - 1) pageNumbers.push('...');
            pageNumbers.push(totalPages);
        }
        return pageNumbers;
    };

    if (loading) {
        return (
            <div className='app-container p-4'>
                <Header title={txt.title} />
                <div className="loader-wrapper">
                    <div className="spinner"></div>
                    <p className="loader-text">{txt.loadingData}</p>
                </div>
            </div>
        );
    }

    return (
        <div className='app-container p-4'>
            <Header title={txt.title} />


            {/* Mobile Number Edit Modal */}
            {isEditMobileOpen && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15, 23, 42, 0.6)', backdropFilter: 'blur(4px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10000 }} onClick={() => setIsEditMobileOpen(false)}>
                    <div className="slide-up-element" style={{ background: 'white', padding: '24px', borderRadius: '16px', width: '90%', maxWidth: '350px', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)' }} onClick={(e) => e.stopPropagation()}>
                        <h4 style={{ margin: '0 0 16px 0', fontSize: '18px', color: '#0f172a', fontWeight: '700' }}>{txt.editMobileTitle}</h4>
                        <p style={{ margin: '0 0 12px 0', fontSize: '13px', color: '#64748b' }}>{editingVoter?.eng_f_name} {editingVoter?.eng_surname}</p>

                        <div style={{ marginBottom: '24px' }}>
                            <input
                                type="tel"
                                maxLength="10"
                                value={newMobile}
                                onChange={(e) => setNewMobile(e.target.value.replace(/[^0-9]/g, ''))}
                                style={{
                                    width: '100%',
                                    padding: '12px 16px',
                                    border: (newMobile && !/^[6-9]\d{9}$/.test(newMobile) && newMobile.length === 10) ? '1px solid #ef4444' : '1px solid #cbd5e1',
                                    borderRadius: '10px',
                                    fontSize: '15px',
                                    outline: 'none',
                                    boxSizing: 'border-box'
                                }}
                                placeholder={txt.mobilePlaceholder}
                                autoFocus
                            />
                            {newMobile && newMobile.length > 0 && !/^[6-9]\d{9}$/.test(newMobile) && (
                                <div style={{ fontSize: '11px', color: '#ef4444', marginTop: '6px', fontWeight: '500' }}>
                                    {newMobile.length < 10 ? txt.mobileErrorLength : txt.mobileErrorStart}
                                </div>
                            )}
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                            <button
                                onClick={() => setIsEditMobileOpen(false)}
                                style={{ padding: '10px 16px', background: 'white', color: '#475569', border: '1px solid #cbd5e1', borderRadius: '10px', cursor: 'pointer', fontWeight: '600' }}
                            >
                                {txt.cancel}
                            </button>
                            <button
                                onClick={handleUpdateMobile}
                                disabled={isSavingMobile || !/^[6-9]\d{9}$/.test(newMobile)}
                                style={{
                                    padding: '10px 20px',
                                    background: (!/^[6-9]\d{9}$/.test(newMobile)) ? '#94a3b8' : '#2563eb',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '10px',
                                    cursor: (!/^[6-9]\d{9}$/.test(newMobile)) ? 'not-allowed' : 'pointer',
                                    fontWeight: '600'
                                }}
                            >
                                {isSavingMobile ? txt.saving : txt.save}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* --- PROFESSIONAL FILTER CONTAINER with Search and Filter Dropdown --- */}
            <div className="filter-container">
                <div className="search-wrapper">
                    <svg className="search-icon-main" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                    <input
                        type="text"
                        className="search-input"
                        placeholder={txt.searchPlaceholder}
                        value={searchTerm}
                        onChange={(e) => {
                            setSearchTerm(e.target.value);
                            setCurrentPage(1);
                        }}
                    />
                    {searchTerm && (
                        <button className="clear-search-btn" onClick={() => {
                            setSearchTerm('');
                            setCurrentPage(1);
                        }}>
                            <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                        </button>
                    )}
                </div>

                {/* Filter Dropdown Button */}
                <div className="filter-dropdown-container">
                    <button
                        className="filter-btn"
                        onClick={() => setIsFilterDropdownOpen(!isFilterDropdownOpen)}
                    >
                        <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                            <polygon points="22 3 2 3 10 13 10 21 14 18 14 13 22 3" />
                        </svg>
                        {getFilterButtonText()}
                        <svg width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                            <polyline points="6 9 12 15 18 9" />
                        </svg>
                    </button>

                    {isFilterDropdownOpen && (
                        <div className="filter-dropdown-menu">
                            <button
                                className={`filter-option ${filterStatus === 'all' ? 'active' : ''}`}
                                onClick={() => { setFilterStatus('all'); setIsFilterDropdownOpen(false); setCurrentPage(1); }}
                            >
                                {txt.all}
                            </button>
                            <button
                                className={`filter-option ${filterStatus === 'available' ? 'active' : ''}`}
                                onClick={() => { setFilterStatus('available'); setIsFilterDropdownOpen(false); setCurrentPage(1); }}
                            >
                                <span className="filter-dot available-dot"></span>
                                {txt.surveyAvailable}
                            </button>
                            <button
                                className={`filter-option ${filterStatus === 'not_available' ? 'active' : ''}`}
                                onClick={() => { setFilterStatus('not_available'); setIsFilterDropdownOpen(false); setCurrentPage(1); }}
                            >
                                <span className="filter-dot not-available-dot"></span>
                                {txt.surveyNotAvailable}
                            </button>
                            <button
                                className={`filter-option ${filterStatus === 'pending' ? 'active' : ''}`}
                                onClick={() => { setFilterStatus('pending'); setIsFilterDropdownOpen(false); setCurrentPage(1); }}
                            >
                                <span className="filter-dot pending-dot"></span>
                                {txt.surveyPending}
                            </button>
                        </div>
                    )}
                </div>
            </div>

            {/* --- Results Grid (same card style as SpeakAndSearch) --- */}
            <div className="row g-4 mt-1 pb-5">
                {currentVoters.map((voter, index) => {
                    // Determine full name
                    const fullName = `${voter.eng_f_name !== "-" ? voter.eng_f_name : ""} ${voter.eng_m_name !== "-" ? voter.eng_m_name : ""} ${voter.eng_surname !== "-" ? voter.eng_surname : ""}`.trim();
                    const displayName = fullName || "UNKNOWN VOTER";

                    return (
                        <div className="col-12 col-md-6 col-lg-4" key={voter.id || index}>
                            <div className="voter-card-clean h-100">
                                {/* Header with Survey Status */}
                                <div className="voter-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div>
                                        <span className="serial-number">{index + 1 + indexOfFirstItem}.</span>
                                        <span className="voter-name-bold ms-2">{displayName}</span>
                                    </div>
                                    <div>
                                        {voter.voter_available === null && (
                                            <button
                                                className="btn-add-survey"
                                                onClick={(e) => { e.stopPropagation(); /* Add your survey logic here */ }}
                                            >
                                                + {txt.addSurvey}
                                            </button>
                                        )}
                                        {voter.voter_available === true && (
                                            <span className="badge-status status-positive">
                                                {getStatusFullForm(voter.voter_status)}
                                            </span>
                                        )}
                                        {voter.voter_available === false && (
                                            <span className="badge-status status-negative">
                                                {voter.not_available_reason || 'Not Available'}
                                            </span>
                                        )}
                                    </div>
                                </div>

                                <div className="voter-body position-relative">
                                <div className="info-row"><span className="label">{txt.fs}</span><span className="value">{voter.eng_f_name !== "-" ? voter.eng_f_name : "N/A"}</span></div>
                                    <div className="info-row"><span className="label">{txt.address}</span><span className="value">{voter.eng_localityid || "N/A"}</span></div>
                                    <div className="info-row"><span className="label">{txt.srNo}</span><span className="value">{voter.slnoinpart || "-"}</span></div>
                                    <div className="info-row" style={{ display: 'flex', alignItems: 'center' }}>
                                        <span className="label">{txt.mobile}</span>
                                        <span className="value mobile-value" style={{ flexGrow: 1 }}>{voter.contact_no || "N/A"}</span>
                                        <svg
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setEditingVoter(voter);
                                                setNewMobile(voter.contact_no || '');
                                                setIsEditMobileOpen(true);
                                            }}
                                            style={{ cursor: 'pointer', color: '#f59e0b', width: '18px', height: '18px', flexShrink: 0 }}
                                            fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"
                                        >
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                        </svg>
                                    </div>
                                    <div className="info-row"><span className="label">{txt.idCardNo}</span><span className="value">{voter.idcard_no || "-"}</span></div>
                                    <div className="info-row"><span className="label">{txt.boothNoLabel}</span><span className="value">{voter.booth_no || "-"}</span></div>
                                    <div className="info-row"><span className="label">{txt.houseNo}</span><span className="value">{voter.eng_house_no !== "-" ? voter.eng_house_no : "N/A"}</span></div>
                                    <div className="info-row"><span className="label">{txt.votingLoc}</span><span className="value">{voter.eng_polling_location !== "-" ? voter.eng_polling_location : "-"}</span></div>
                                </div>
                                <div className="voter-actions">
                                    <ActionButton icon={voterIcons.call} color={VOTER_ORANGE} label={txt.call}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            if (!voter.contact_no || voter.contact_no === "N/A" || voter.contact_no === "-" || voter.contact_no === "") {
                                                alert("Mobile number is not available for this voter.");
                                            }
                                            else {
                                                window.open(`tel:${voter.contact_no}`, '_blank');
                                            }
                                        }}

                                    />
                                    <ActionButton icon={voterIcons.text} color={VOTER_ORANGE} label={txt.text} onClick={() => handleSmsShare(voter)} />
                                    <WhatsappSlipButton voter={voter} />

                                    <PracharButton voter={voter} />
                                    <ActionButton
                                        icon={voterIcons.print} color={VOTER_ORANGE}
                                        label={txt.print}
                                        onClick={() => navigate('/printer', { state: { voter_id: voter.id } })}
                                    />
                                    <ActionButton icon={voterIcons.family} color={VOTER_ORANGE} label={txt.family} onClick={() => navigate('/dis_family_member', { state: { voter_id: voter.id } })} />
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>

            {/* --- Pagination (same as SpeakAndSearch) --- */}
            {!loading && filteredVoters.length > itemsPerPage && (
                <div className="pagination-wrapper">
                    <div className="pagination-content">
                        <button className="pagination-nav-btn" onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                            <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" /></svg>
                        </button>
                        <div className="page-numbers">
                            {getPageNumbers().map((number, idx) => (
                                <React.Fragment key={idx}>
                                    {number === '...' ? (<span className="page-dots">...</span>) : (
                                        <button className={`page-num-btn ${currentPage === number ? 'active' : ''}`} onClick={() => paginate(number)}>{number}</button>
                                    )}
                                </React.Fragment>
                            ))}
                        </div>
                        <button className="pagination-nav-btn" onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
                            <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" /></svg>
                        </button>
                    </div>
                </div>
            )}

            {/* No Results Message */}
            {!loading && filteredVoters.length === 0 && (
                <div className="no-data-message">
                    <div className="no-data-icon">📭</div>
                    <div className="no-data-text">
                        {searchTerm ? `${txt.noResults} "${searchTerm}"` : txt.noData}
                    </div>
                </div>
            )}

            <style jsx>{`
                .app-container { 
                    background: #E5E7EB; 
                    min-height: 100vh; 
                    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; 
                }
                
                /* Filter Container - same as SpeakAndSearch */
                .filter-container { 
                    display: flex; 
                    justify-content: space-between; 
                    align-items: center; 
                    gap: 16px; 
                    margin-bottom: 24px; 
                }
                .search-wrapper { 
                    position: relative; 
                    flex: 1; 
                    max-width: 100%; 
                }
                .search-icon-main { 
                    position: absolute; 
                    left: 14px; 
                    top: 50%; 
                    transform: translateY(-50%); 
                    color: #94a3b8; 
                    width: 20px; 
                    height: 20px; 
                    z-index: 1;
                }
                .search-input { 
                    width: 100%; 
                    padding: 12px 100px 12px 42px; 
                    border: 1px solid #e2e8f0; 
                    border-radius: 10px; 
                    font-size: 14px; 
                    color: #1e293b; 
                    outline: none; 
                    transition: all 0.2s ease; 
                    box-shadow: 0 1px 2px rgba(0,0,0,0.05); 
                }
                .search-input:focus { 
                    border-color: #2563eb; 
                    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1); 
                }
                .clear-search-btn {
                    position: absolute;
                    right: 12px;
                    top: 50%;
                    transform: translateY(-50%);
                    background: #f1f5f9;
                    border: none;
                    color: #64748b;
                    padding: 6px;
                    border-radius: 50%;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transition: all 0.2s ease;
                    z-index: 2;
                }
                .clear-search-btn:hover {
                    background: #e2e8f0;
                    color: #1e293b;
                }

                /* Filter Dropdown Styles */
                .filter-dropdown-container {
                    position: relative;
                }
                .filter-btn {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    padding: 10px 16px;
                    background: white;
                    border: 1px solid #e2e8f0;
                    border-radius: 10px;
                    font-size: 13px;
                    font-weight: 600;
                    color: #1e293b;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    white-space: nowrap;
                }
                .filter-btn:hover {
                    background: #f8fafc;
                    border-color: #cbd5e1;
                }
                .filter-dropdown-menu {
                    position: absolute;
                    top: 100%;
                    right: 0;
                    margin-top: 8px;
                    background: white;
                    border: 1px solid #e2e8f0;
                    border-radius: 12px;
                    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
                    min-width: 180px;
                    z-index: 100;
                    overflow: hidden;
                }
                .filter-option {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    width: 100%;
                    padding: 10px 16px;
                    border: none;
                    background: white;
                    font-size: 13px;
                    font-weight: 500;
                    color: #334155;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    text-align: left;
                }
                .filter-option:hover {
                    background: #f1f5f9;
                }
                .filter-option.active {
                    background: #eff6ff;
                    color: #2563eb;
                }
                .filter-dot {
                    width: 8px;
                    height: 8px;
                    border-radius: 50%;
                    display: inline-block;
                }
                .available-dot {
                    background-color: #22c55e;
                }
                .not-available-dot {
                    background-color: #ef4444;
                }
                .pending-dot {
                    background-color: #f59e0b;
                }
                
                /* Add Survey Button */
                .btn-add-survey {
                    background-color: #3b82f6;
                    color: white;
                    border: none;
                    border-radius: 16px;
                    font-size: 11px;
                    font-weight: 600;
                    padding: 4px 12px;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    white-space: nowrap;
                    display: inline-flex;
                    align-items: center;
                    gap: 4px;
                }
                .btn-add-survey:hover {
                    background-color: #2563eb;
                    transform: translateY(-1px);
                }

                /* Status Badges */
                .badge-status {
                    display: inline-block;
                    border-radius: 16px;
                    font-size: 11px;
                    font-weight: 600;
                    padding: 4px 12px;
                    white-space: nowrap;
                    display: inline-flex;
                    align-items: center;
                }
                .status-positive {
                    background-color: #dcfce7;
                    color: #166534;
                    border: 1px solid #bbf7d0;
                }
                .status-negative {
                    background-color: #fee2e2;
                    color: #991b1b;
                    border: 1px solid #fecaca;
                }
                
                /* Loader styles */
                .loader-wrapper { 
                    display: flex; 
                    flex-direction: column; 
                    justify-content: center; 
                    align-items: center; 
                    min-height: 40vh; 
                    width: 100%; 
                }
                .spinner { 
                    width: 40px; 
                    height: 40px; 
                    border: 4px solid #E5E7EB; 
                    border-top: 4px solid #2563EB; 
                    border-radius: 50%; 
                    animation: spin 1s linear infinite; 
                    margin-bottom: 12px; 
                }
                .loader-text { 
                    color: #6B7280; 
                    font-weight: 500; 
                }
                @keyframes spin { 
                    0% { transform: rotate(0deg); } 
                    100% { transform: rotate(360deg); } 
                }
                
                /* Pagination styles */
                .pagination-wrapper { 
                    display: flex; 
                    justify-content: center; 
                    padding: 20px 0; 
                    position: sticky; 
                    bottom: 20px; 
                    z-index: 50; 
                    pointer-events: none; 
                }
                .pagination-content { 
                    background: white; 
                    border: 1px solid #E2E8F0; 
                    border-radius: 50px; 
                    padding: 8px 16px; 
                    display: flex; 
                    align-items: center; 
                    gap: 10px; 
                    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1); 
                    pointer-events: auto; 
                }
                .pagination-nav-btn { 
                    display: flex; 
                    align-items: center; 
                    justify-content: center; 
                    width: 36px; 
                    height: 36px; 
                    border-radius: 50%; 
                    background: transparent; 
                    border: none; 
                    color: #2563EB; 
                    cursor: pointer; 
                }
                .pagination-nav-btn:disabled { 
                    color: #CBD5E1; 
                    cursor: not-allowed; 
                }
                .page-numbers { 
                    display: flex; 
                    gap: 5px; 
                    align-items: center; 
                }
                .page-num-btn { 
                    width: 32px; 
                    height: 32px; 
                    border-radius: 50%; 
                    border: 1px solid transparent; 
                    background: transparent; 
                    color: #475569; 
                    font-weight: 600; 
                    font-size: 14px; 
                    cursor: pointer; 
                }
                .page-num-btn.active { 
                    background-color: #2563EB; 
                    color: white; 
                }
                .page-dots { 
                    color: #94A3B8; 
                    font-weight: bold; 
                    padding: 0 4px; 
                }
                
                /* No data message */
                .no-data-message {
                    text-align: center;
                    padding: 60px 20px;
                    background: white;
                    border-radius: 16px;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
                    border: 1px dashed #cbd5e1;
                    margin-top: 20px;
                }
                .no-data-icon {
                    font-size: 54px;
                    margin-bottom: 16px;
                }
                .no-data-text {
                    font-size: 16px;
                    font-weight: 600;
                    color: #64748b;
                }
                
                /* Mobile Optimization */
                @media (max-width: 640px) { 
                    .filter-container { 
                        flex-direction: column;
                        width: 100%;
                    }
                    .search-wrapper { 
                        width: 100%;
                        max-width: 100%;
                    }
                    .search-input {
                        padding: 10px 90px 10px 36px;
                        font-size: 13px;
                    }
                    .search-icon-main {
                        left: 10px;
                        width: 16px;
                        height: 16px;
                    }
                    .filter-dropdown-container {
                        width: 100%;
                    }
                    .filter-btn {
                        justify-content: center;
                        width: 100%;
                    }
                    .filter-dropdown-menu {
                        right: auto;
                        left: 0;
                        width: 100%;
                    }
                    .row.g-4 {
                        margin-left: -8px;
                        margin-right: -8px;
                    }
                    [class*="col-"] {
                        padding-left: 8px;
                        padding-right: 8px;
                    }
                    .pagination-content {
                        padding: 6px 12px;
                    }
                    .page-num-btn {
                        width: 28px;
                        height: 28px;
                        font-size: 12px;
                    }
                    .pagination-nav-btn {
                        width: 32px;
                        height: 32px;
                    }
                    .circle-btn {
                        width: 38px;
                        height: 38px;
                        font-size: 16px;
                    }
                    .btn-label {
                        font-size: 10px;
                    }
                    .label {
                        width: 75px;
                        font-size: 12px;
                    }
                    .value {
                        font-size: 12px;
                    }
                    .voter-name-bold {
                        font-size: 15px;
                    }
                    .btn-add-survey {
                        font-size: 10px;
                        padding: 3px 10px;
                    }
                    .badge-status {
                        font-size: 10px;
                        padding: 3px 10px;
                    }
                }
            `}</style>
        </div>
    );
};

// Updated ActionButton to accept onClick props
const ActionButton = ({ icon, color, label, link, onClick }) => {
    if (onClick) {
        return (
            <button onClick={onClick} className="action-btn-wrapper" style={{ textDecoration: 'none', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
                <div className="circle-btn" style={{ backgroundColor: color }}>{icon}</div>
                <span className="btn-label">{label}</span>
            </button>
        );
    }

    return (
        <a href={link || "#"} className="action-btn-wrapper" style={{ textDecoration: 'none' }} target="_blank" rel="noreferrer">
            <div className="circle-btn" style={{ backgroundColor: color }}>{icon}</div>
            <span className="btn-label">{label}</span>
        </a>
    );
};

export default BoothWiseVoter;
